import { render, staticRenderFns } from "./PaymentsListDesktopView.vue?vue&type=template&id=95865cd0&"
import script from "./PaymentsListDesktopView.vue?vue&type=script&lang=js&"
export * from "./PaymentsListDesktopView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports